import { css } from '@emotion/core';
import vars from '../../styles/vars';
var _ref = {
  name: "1139qbz",
  styles: "&,&:hover,&:active{text-decoration:none;}"
};
var _ref2 = {
  name: "8atqhb",
  styles: "width:100%;"
};
export default _ref3 => {
  var type = _ref3.type,
    stretched = _ref3.stretched,
    iconOnly = _ref3.iconOnly;
  return /*#__PURE__*/css("display:inline-block;padding:", iconOnly ? vars.size.regular.iconOnlyPadding : vars.size.regular.padding, ";border:", vars.base.borderWidth, " solid ", vars.base.borderColour, ";transition:background-color 0.2s linear,border-color 0.2s linear,color 0.2s linear;font-size:", vars.size.regular.fontSize, ";line-height:", vars.size.regular.lineHeight, ";font-weight:", vars.base.fontWeight, ";text-align:center;cursor:pointer;appearance:none;", type === 'link' && _ref, " ", stretched && _ref2);
};